import { render, staticRenderFns } from "./manual_create_details-for-no-enrollment.vue?vue&type=template&id=02bc6ce6&scoped=true&"
import script from "./manual_create_details-for-no-enrollment.vue?vue&type=script&lang=js&"
export * from "./manual_create_details-for-no-enrollment.vue?vue&type=script&lang=js&"
import style0 from "./manual_create_details-for-no-enrollment.vue?vue&type=style&index=0&id=02bc6ce6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc6ce6",
  null
  
)

export default component.exports